import type { NavItemType } from 'types/menu';

// Regra única de visibilidade de item no menu por permissão (reuso: NavGroup, NavCollapse).
// É só apresentação — o enforcement real de acesso continua no RouteGuard das rotas.
export function canAccess(item: NavItemType, ctx: { permissions: string[]; hasPermission: (permission: string) => boolean }): boolean {
  if (item.permissionsPrefix) {
    // Lista ou string única, e os prefixos combinam em OR — mesmo contrato do `PermissionGuard`.
    // Antes era só string, e um array aqui silenciosamente viraria "colaboradores.a,colaboradores.b"
    // no `startsWith`: o item desapareceria do menu para todo mundo, sem erro nenhum.
    const prefixos = Array.isArray(item.permissionsPrefix) ? item.permissionsPrefix : [item.permissionsPrefix];
    if (!prefixos.some((prefixo) => ctx.permissions.some((p) => p.startsWith(prefixo)))) {
      return false;
    }
  }
  if (!item.permissions || item.permissions.length === 0) {
    return true;
  }
  return item.permissions.some((p) => ctx.hasPermission(p));
}
